import { AnimatePresence, motion } from 'framer-motion'
import { useToastStore } from '../../lib/toastStore'

export default function Toasts() {
  const { toasts, removeToast } = useToastStore()

  return (
    <div className="fixed bottom-24 inset-x-0 flex flex-col items-center gap-2 z-50 pointer-events-none px-4">
      <AnimatePresence>
        {toasts.map(t => {
          const pillBg =
            t.type === 'error' ? 'bg-[#C25B4E]' :
            t.type === 'info'  ? 'bg-[#4A90D9]' :
                                 'bg-[#2C2A26]'

          return (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 16, scale: 0.95 }}
              animate={{ opacity: 1, y: 0,  scale: 1    }}
              exit={{    opacity: 0, y: 8,  scale: 0.97 }}
              transition={{ duration: 0.2 }}
              className={`pointer-events-auto flex items-center gap-3 rounded-2xl shadow-xl max-w-[360px] min-w-[240px] text-white ${pillBg}`}
            >
              <button
                onClick={() => removeToast(t.id)}
                className="flex-1 text-left px-5 py-3 font-serif text-[13px] leading-[1.35]"
              >
                {t.message}
              </button>
              {t.action && (
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    t.action!.onClick()
                    removeToast(t.id)
                  }}
                  className="flex-shrink-0 pr-5 py-3 font-serif text-[13px] italic font-semibold text-sand hover:text-cream transition"
                >
                  {t.action.label}
                </button>
              )}
            </motion.div>
          )
        })}
      </AnimatePresence>
    </div>
  )
}
